module.exports = __webpack_public_path__ + "img/sq_header_kdykoliv.768d3c2c.jpg";